var play_icon_rtlignore_default = {
  "shadow": "QN-kk",
  "playIcon": "hkyvw"
};
export {
  play_icon_rtlignore_default as default
};
//# sourceMappingURL=play-icon.rtlignore-scss.js.map
